import Link from 'next/link';
import { Collapse } from 'antd';
import styled from 'styled-components';

import { media } from '@/shared/components';
import { COLORS } from '@/shared/constants/colors';

import { ButtonIw } from '../../components/ButtonIw';

export const Container = styled.div`
  padding-bottom: 24px;
  max-width: 600px;

  ${media.mobile} {
    width: 100%;
    padding-bottom: 0;
  }
`;

export const Dialog = styled.div`
  width: 100%;
  padding: 24px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  background: ${COLORS.systemLight100};

  ${media.mobile} {
    height: auto;
  }
`;

export const DialogTitle = styled.h1`
  font-size: 18px;
  line-height: 26px;
  font-weight: 700;
`;

export const SectionTitle = styled.h2`
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 8px;
`;

export const OrderedList = styled.ol`
  padding-left: 20px;

  li {
    list-style: decimal;
  }
`;

export const UnorderedList = styled.ul`
  padding-left: 20px;

  li {
    list-style: disc;
  }
`;

export const SectionLink = styled(Link)`
  &&& {
    font-weight: 700;
    text-decoration: underline;
  }
`;

export const StyledButton = styled(ButtonIw)`
  &&& {
    font-weight: 700;
  }
`;

export const StyledCollapse = styled(Collapse)`
  &&& {
    & {
      display: flex;
      flex-direction: column;
      gap: 24px;
    }

    &,
    .ant-collapse-content,
    .ant-collapse-item {
      border: none;
      background: transparent;
    }

    .ant-collapse-content-box {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    .ant-collapse-item {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    .ant-collapse-header-text {
      font-weight: 700;
    }

    .ant-collapse-arrow {
      font-size: 20px !important;
    }

    .ant-collapse-arrow {
      color: ${COLORS.systemSky200} !important;
    }
  }
`;

export const DisclaimerContainer = styled.div`
  padding: 16px;
  border-radius: 12px;
  background: ${COLORS.systemLight200};

  &&& {
    .ant-collapse-item,
    .ant-collapse-content-box {
      gap: 16px;
    }
  }
`;
